var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVkColorDarkPadding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 50,
    viewBox: "0 0 200 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VK"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vk-color-dark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VK.com-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M94.1733 6H105.827C116.467 6 119 8.53333 119 19.1733V30.8267C119 41.4667 116.467 44 105.827 44H94.1733C83.5333 44 81 41.4667 81 30.8267V19.1733C81 8.53333 83.5333 6 94.1733 6Z",
    fill: "#5181B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M112.119 19.0915C112.295 18.5044 112.119 18.073 111.281 18.073H108.51C107.806 18.073 107.481 18.4457 107.305 18.8566C107.305 18.8566 105.896 22.2912 103.9 24.5222C103.254 25.1679 102.96 25.3734 102.608 25.3734C102.432 25.3734 102.177 25.1679 102.177 24.5809V19.0915C102.177 18.387 101.973 18.073 101.385 18.073H97.0313C96.591 18.073 96.3262 18.4 96.3262 18.7099C96.3262 19.3778 97.3242 19.5318 97.4271 21.4105V25.4909C97.4271 26.3855 97.2655 26.5477 96.9133 26.5477C95.9739 26.5477 93.689 23.0978 92.3339 19.1502C92.0683 18.3829 91.8019 18.073 91.0938 18.073H88.3229C87.5313 18.073 87.3729 18.4457 87.3729 18.8566C87.3729 19.5905 88.3123 23.2306 91.7468 28.0448C94.0365 31.3325 97.2624 33.1147 100.198 33.1147C101.959 33.1147 102.177 32.7188 102.177 32.037V29.5522C102.177 28.7605 102.344 28.6025 102.902 28.6025C103.313 28.6025 104.017 28.808 105.661 30.3932C107.54 32.2719 107.85 33.1147 108.906 33.1147H111.677C112.469 33.1147 112.865 32.7188 112.636 31.9377C112.386 31.1591 111.489 30.0296 110.299 28.6906C109.653 27.9273 108.685 27.1054 108.391 26.6944C107.98 26.1661 108.098 25.9312 108.391 25.4615C108.391 25.4615 111.767 20.706 112.119 19.0915Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkColorDarkPadding);
export default __webpack_public_path__ + "static/media/vk-color-dark-padding.2cbe3d606d4e233a170c22d7a859af6f.svg";
export { ForwardRef as ReactComponent };